<template lang="pug">
  .component-create-entity-button
    ModalReveal(ref="documentTypeReveal")
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      h2 Create new document type
      DocumentTypeForm(v-model="documentType" )
      template(slot="footer" )
        ActionButton(:action="save") Save

</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import ActionButton from "../ActionButton.vue";
import {EventBus} from "../../../../eventBus";
import DocumentTypeForm from "../../forms/DocumentTypeForm.vue";

export default {
  name: 'CreateDocumentTypeButtonModal',
  components: {DocumentTypeForm, ActionButton, ModalReveal},
  data() {
    return {
      documentType: {
        name: null,
        description: null,
        attachment_views: [],
        has_number: true,
        has_emission: true,
        has_expiry: true,
        has_issuer: true,
        has_country: true
      }
    }
  },
  created() {
  },
  methods: {
    save() {
      return KeplerBackofficeSdk.documentTypes.make(this.documentType, () => {
        this.$refs.documentTypeReveal.close()
        EventBus.$emit('reload-list')
      })
    }
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateDocumentTypeButtonModal.vue?446474d4